import { withInstall } from '../utils'
import Index from './src/index.vue'
import Pro from './src/pro.vue'

export const PassControl = withInstall(Index)
export const PassControlPro = withInstall(Pro)
